<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.8763 2.59303C12.4964 1.90226 11.5038 1.90226 11.1239 2.59303L1.81515 19.518C1.4486 20.1844 1.93076 20.9999 2.69137 20.9999H21.3088C22.0694 20.9999 22.5516 20.1844 22.185 19.518L12.8763 2.59303ZM13.0002 13.9994V7.99942H11.0001V13.9994H13.0002ZM13.0002 18.0001V16H11.0001V18.0001H13.0002Z"
    />
  </svg>
</template>
